import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withStyles } from '@material-ui/core/styles'
import { Dialog as D } from '@material-ui/core'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '../Button'

const MuiDialog = withStyles({
  container: {
    transition:
      'width 0.2s cubic-bezier(0.22, 0.61, 0.36, 1) 0ms,margin 0.2s cubic-bezier(0.68, -0.55, 0.27, 1.55) 0ms !important'
  },
  paper: {
    background: 'center'
  }
})(D)

export const Dialog = (props) => {
  const {
    title,
    content,
    className,
    actions,
    style,
    open,
    onClose,
    cancel,
    width,
    height,
    contentJustify,
    contentDisplay
  } = props

  return (
    <MuiDialog
      open={open}
      style={{
        overflowY: 'unset',
        background: '#000000ad'
      }}
      className={clsx(className, 'text-color')}
      aria-labelledby="dialog"
      aria-describedby="bund-dialog">
      <DialogTitle className="text-color card-body-color" id="dialog-title">
        {title}
      </DialogTitle>
      <DialogContent
        aria-labelledby="dialog-content"
        style={{
          width: width,
          height: height
        }}
        className="text-color card-body-color">
        <div
          style={{
            justifyContent: contentJustify,
            display: contentDisplay
          }}
          className="text-color card-body-color"
          id="dialog-content">
          {content}
        </div>
      </DialogContent>
      <DialogActions id="dialog-actions" className="text-color card-body-color">
        <div
          style={{
            display: 'flex',
            alignItems: 'center'
          }}>
          {cancel && (
            <Button
              size="xs"
              onClick={onClose}
              variant="text"
              className="text-color"
              style={style}
              type="submit">
              Cancel
            </Button>
          )}
          {actions}
        </div>
      </DialogActions>
    </MuiDialog>
  )
}

Dialog.propTypes = {
  content: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  actions: PropTypes.node.isRequired,
  cancel: PropTypes.bool,
  open: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onClose: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  contentJustify: PropTypes.string,
  contentDisplay: PropTypes.string
}

Dialog.defaultProps = {
  title: 'Are You Sure ?',
  width: '440px',
  height: '140px',
  contentJustify: 'unset',
  contentDisplay: 'contents'
}

Dialog.displayName = 'd'

export default Dialog
